module.exports = __webpack_public_path__ + "static/media/Mitutoyo2.68deb921.png";